import React, { useEffect } from "react";
import CreateIncidentForm from "./CreateIncidentForm";
import { CreateIncidentModalProps } from "../types/types";

const CreateIncident: React.FC<CreateIncidentModalProps> = ({
  showModal,
  setShowModal,
  departmentName,
  onIncidentCreated,
  mode = "create",
  incidentId,
  moduleKey,
}) => {
  const handleSuccess = () => {
    setShowModal(false);
    if (onIncidentCreated) {
      onIncidentCreated();
    }
  };

  useEffect(() => {
    if (showModal) {
      document.body.classList.add("overflow-hidden");
      document.body.classList.add("modal-open");
    } else {
      document.body.classList.remove("overflow-hidden");
      document.body.classList.remove("modal-open");
    }
    return () => {
      document.body.classList.remove("overflow-hidden");
      document.body.classList.remove("modal-open");
    };
  }, [showModal]);

  const getModalTitle = () => {
    switch (mode) {
      case "view":
        return "View Incident";
      case "update":
        return "Update Incident";
      default:
        return "Create Incident";
    }
  };

  if (!showModal) return null;

  return (
    <div className="fixed inset-0 z-[1000] bg-black bg-opacity-50 flex items-start justify-end">
      <div className="w-full max-w-5xl h-full bg-white shadow-2xl flex flex-col modal-slide">
        {/* Header */}
        <div className="sticky top-0 z-10 bg-white flex justify-between items-center px-6 py-2 border-b flex-shrink-0">
          <h2 className="text-xl font-semibold text-[#1b428a]">
            {getModalTitle()}
          </h2>
          <button
            onClick={() => setShowModal(false)}
            className="text-xl font-bold text-gray-600 hover:text-red-500"
          >
            ×
          </button>
        </div>

        {/* Form Content */}
        <div className="flex-1 flex flex-col min-h-0 overflow-y-auto">
          <CreateIncidentForm
            departmentName={departmentName}
            onSuccess={handleSuccess}
            mode={mode}
            incidentId={incidentId}
            moduleKey={moduleKey}
          />
        </div>
      </div>
    </div>
  );
};

export default CreateIncident;
